import type { DataGridCellRendererProps } from '@myosh/odin-components';
import { DataGridDataCell } from '@myosh/odin-components';
import DOMPurify from 'dompurify';
import dot from 'dot-object';
import type { Ref } from 'react';
import React, { forwardRef, useMemo } from 'react';

const RichTextAreaDataCell = ({ column, rowData }: DataGridCellRendererProps, forwardRef: Ref<HTMLDivElement>) => {
  const value = (column.valuePath ? dot.pick(column.valuePath, rowData) : '') ?? '';
  const displayValue = useMemo(() => DOMPurify.sanitize(value, { USE_PROFILES: { html: true } }), [value]);

  return <DataGridDataCell ref={forwardRef} value={displayValue} width={column.width} renderAsInnerHTML />;
};

export default forwardRef(RichTextAreaDataCell);
